// ! This is a client-side Component

import AppsList from "components/AppsList";
import React from "react";
import { RecentGamesService } from "service/RecentGamesService";

function RecentGameList({ title }) {
  const recentGameList = RecentGamesService.getGames();
  if (!recentGameList?.length) return null;
  return <AppsList apps={recentGameList} title={title} favorite />;
}

export default RecentGameList;
